import RendererTypesEnum from "./RendererTypesEnum";
var FilterTypeEnum = /* @__PURE__ */ ((FilterTypeEnum2) => {
  FilterTypeEnum2["RANGE"] = "range";
  FilterTypeEnum2["RADIO"] = "radio";
  FilterTypeEnum2["CHECKBOX"] = "checkbox";
  FilterTypeEnum2["SWATCH"] = "swatch";
  FilterTypeEnum2["YES_NO"] = "yes_no";
  return FilterTypeEnum2;
})(FilterTypeEnum || {});
function config() {
  return [
    {
      frontend_input: "price",
      type: "range" /* RANGE */,
      component: RendererTypesEnum.RANGE
    },
    {
      frontend_input: "boolean",
      type: "yes_no" /* YES_NO */,
      component: RendererTypesEnum.YES_NO
    },
    {
      frontend_input: "select",
      type: "checkbox" /* CHECKBOX */,
      component: RendererTypesEnum.CHECKBOX
    },
    {
      frontend_input: "swatch",
      type: "swatch" /* SWATCH */,
      component: RendererTypesEnum.SWATCH
    },
    {
      frontend_input: "multiselect",
      type: "checkbox" /* CHECKBOX */,
      component: RendererTypesEnum.CHECKBOX
    }
  ];
}
export {
  FilterTypeEnum,
  config as default
};
